import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const SSlider = ({ disabled, onClick, value, className, onChange, min, max, step })=>{
    // const [active, setActive] = React.useState(false)
    // const [hover, setHover] = React.useState(false)
    return /*#__PURE__*/ _jsxs("div", {
        className: `relative flex items-center justify-center h-[36px] w-[125px] ${className}`,
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: {
                    width: `calc(${100 * (Math.min(value, max) - min) / (max - min)}%)`
                },
                className: "absolute top-[50%] h-[5px] translate-y-[-50%] z-0 left-[0px]  rounded-full bg-brand-primary/30 border border-brand-primary/10"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "absolute top-[50%] h-[5px] translate-y-[-50%] z-0 left-[0px] right-[0px] rounded-full bg-brand-primary/7 border border-brand-primary/10 "
            }),
            /*#__PURE__*/ _jsx("input", {
                type: "range",
                className: "relative z-1 appearance-none cursor-pointer accent-brand-primary transition-opacity w-[calc(100%)] !bg-transparent",
                min: min,
                max: max,
                tabIndex: -1,
                step: step,
                onClick: onClick,
                value: value,
                onChange: (e)=>onChange(parseFloat(e.target.value))
            })
        ]
    });
};
SSlider.displayName = "SSlider";
export { SSlider };
